import React from "react";
import MaterialTable from "material-table";
import SnackBarWiiba from "components/Snackbar/SnackBarWiiba";
import useContract from "hooks/useContract";
import useMessage from "hooks/useMessage";

export default function ConsultaDesarrollo() {
  const {
    opensnack,
    typesnackbar,
    message,
    handleMuestraSnack,
    handleClosesSnack
  } = useMessage();

  const { column, contracts, handleSearchContract } = useContract({
    handleMuestraSnack
  });
  return (
    <div>
      <SnackBarWiiba
        opensnack={opensnack}
        tipoSnackBar={typesnackbar}
        mensaje={message}
        handleClosesSnack={handleClosesSnack}
      />
      <MaterialTable
        title="Lista de desarrollos"
        columns={column}
        data={contracts}
      />
    </div>
  );
}
